export const sanitizeItems = (items) => {
  const validIds = new Set(items.map(i => i.id));
  return items.map(item => {
    if (item.childItems) {
      return {
        ...item,
        childItems: item.childItems.filter(childId => validIds.has(childId))
      };
    }
    return item;
  });
};